import { Link } from 'react-router-dom';
import { LegalChrome } from './LegalChrome';
import { CHILD_SAFETY_CONTACT_EMAIL } from './constants';

const LAST_UPDATED = 'April 17, 2026';

export function ChildSafetyPage() {
  return (
    <LegalChrome>
      <h1 className="legal-h1">Child Safety Standards for Kynward</h1>
      <p className="legal-muted">Last updated: {LAST_UPDATED}</p>

      <p className="legal-p">
        Kynward, operated by Elyxora Works, is committed to protecting users from child sexual abuse
        and exploitation (CSAE). We prohibit any content, behavior, or interaction that sexually
        exploits, abuses, endangers, or attempts to exploit a child.
      </p>

      <h2 className="legal-h2">Prohibited content and behavior</h2>
      <p className="legal-p">
        Users may not use Kynward to create, upload, share, request, solicit, promote, or distribute
        child sexual abuse material (CSAM). Users also may not use Kynward for grooming, sexual
        exploitation of minors, sextortion of minors, trafficking of minors for sexual purposes, or
        any other behavior that sexually exploits, abuses, or endangers a child.
      </p>

      <h2 className="legal-h2">Age restrictions</h2>
      <p className="legal-p">
        Kynward is intended only for adults aged 18 and older. We do not permit minors to use the
        app. Accounts identified as underage may be removed.
      </p>

      <h2 className="legal-h2">Reporting</h2>
      <p className="legal-p">
        Users can report profiles, messages, and safety concerns directly within the app. Reports
        involving child safety are reviewed with priority.
      </p>

      <h2 className="legal-h2">Enforcement</h2>
      <p className="legal-p">
        If we become aware of apparent CSAM or CSAE-related behavior, we may remove the content,
        suspend or terminate the associated account, preserve relevant information as appropriate,
        and take additional action consistent with our policies and applicable law.
      </p>

      <h2 className="legal-h2">Legal reporting</h2>
      <p className="legal-p">
        Where required by applicable law, Kynward reports confirmed CSAM to the National Center for
        Missing & Exploited Children (NCMEC) or the relevant regional authority.
      </p>

      <h2 className="legal-h2">Contact</h2>
      <p className="legal-p">
        For child safety concerns or law-enforcement-related inquiries regarding these standards,
        contact:
      </p>
      <p className="legal-p">
        <a className="legal-a" href={`mailto:${CHILD_SAFETY_CONTACT_EMAIL}`}>
          {CHILD_SAFETY_CONTACT_EMAIL}
        </a>
      </p>

      <h2 className="legal-h2">Help center</h2>
      <p className="legal-p">
        For more on how we approach compliance and reporting to regional or national authorities,
        read our{' '}
        <Link className="legal-a" to="/legal/help-center">
          Help center article (child safety & reporting)
        </Link>
        .
      </p>
    </LegalChrome>
  );
}
